<template>
  <div>
  <div
    :class="[
      'w-11/12 md:w-full justify-center whitespace-no-wrap mx-auto py-4 rounded-b-lg flex flex-col  md:sticky md:top-0 md:justify-start shadowFade',
      hasKiosk?'pt-6':'pt-8',
      menu['temp_disabled_msg' + '_' + language] && !menu.is_ordering_enabled
        ? 'flex-col'
        : '',
    ]"
  >
  <div 
  v-if="!searchBarActive"
  class="flex">
      <button 
      v-if="isSearchKiosk"
      class="text-new-primary mr-2 px-6 md:rounded-lg flex justify-center items-center"
      :style="makeStyles(secondButtonRadius , btnSecondBackground, kioskSearchBorderColor, kioskSearchTextColor)"  @click="handleSearchCloseButton">
      <svg class="pr-1" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" :stroke="kioskSearchIconColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M15 18l-6-6 6-6"/></svg>
      Back
    </button>
      <div
        id="scrollbar"
        ref="scrollbar"
        v-scroll="onScroll"
        class="flex max-w-4/5 overflow-x-scroll md:overflow-y-scroll md:rounded-lg md:items-center md:justify-center md:bg-primary-50 rounded-xxl md:w-full"
        :style="makeStyles(secondButtonRadius , btnSecondBackground)"
      >
        <div
          :class="[
            'relative flex md:flex-col md:h-auto h-12 self-center w-full',
            menu['temp_disabled_msg' + '_' + language] &&
            !menu.is_ordering_enabled
              ? 'justify-center'
              : '',
          ]"
          :style="makeStyles(secondButtonRadius , btnSecondBackground)"
        >
          <!-- <div
            v-if="menu.enable_delivery || hasKiosk"
            class="hidden md:block w-11/12 mt-4 mb-6 mx-auto"
          >
            <a
              @click="
              !landingsPageDelivery?
                $router.push({ path: hasKiosk?`/${menuHash}/start/kiosk`: `/${menuHash}/delivery/take-out`,query:$route.query })
                  :''"
              class="rounded-xxl flex items-center justify-center"
              :style="btnThirdBackground"
            >
              <IconTruck
                v-if="currentKioskMode == lang['take_away'][language]"/>
              <IconHome v-else 
              stroke="#9D9D9D"
              />
              <p class="ml-4 text-new-primary font-bold">
                <span v-if="!hasKiosk && currentOption">
                  {{ lang[currentOption][language] }}</span
                >
                <span v-else>{{ currentKioskMode }}</span>
              </p>
            </a>
          </div> -->
          <div 
          v-if="isSearchEnable != 'false'"
          class="hidden md:mr-0 md:h-16 md:rounded-lg rounded-xxl items-center md:flex justify-between pl-6 transition duration-300"
            :style="makeStyles(btnSecondBackground,hasKiosk && secondButtonRadius, isSearchKiosk ?kioskSearchBorderColor : '', isSearchKiosk ? kioskSearchTextColor : '')">
              <input 
              :placeholder="lang['search'][language]"
              v-model="searchInputData"
              @click="handleSearchKiosk"
              @focus="show"
              class="w-full text-xl trasition transform"
              :style="makeStyles(secondButtonRadius , btnSecondBackground)"/>
              <button v-if="!searchInputData && !isSearchKiosk">
              <svg class="inline mr-4" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="#a0aec0" stroke-width="2" stroke-linecap="square" stroke-linejoin="arcs"><circle cx="11" cy="11" r="8"></circle><line x1="21" y1="21" x2="16.65" y2="16.65"></line></svg>              
              </button>
              <button v-if="searchInputData || isSearchKiosk" @click="handleSearchCloseButton">
              <svg class="mr-4" xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="#a0aec0" stroke-width="2" stroke-linecap="square" stroke-linejoin="arcs"><line x1="18" y1="6" x2="6" y2="18"></line><line x1="6" y1="6" x2="18" y2="18"></line></svg>
              </button>
          </div>
          <div
            :ref="[item.Id == selectedMenuCategory.Id ? 'menuCategoryId' : '']"
            :class="[
              'md:mr-0 md:h-16 md:rounded-lg rounded-xxl  flex items-center transition duration-300 cursor-pointer',
              item.Id == selectedMenuCategory.Id
                ? /* theme.body.selectedBackgroundColor */ 'bg-new-primary'
                : /* theme.addToCart.backgroundColor, */ '',
            ]"
            v-for="item in menuCategories"
            v-bind:key="item.id"
            v-if="!isSearchKiosk && ((hasKiosk && !isMobileDevice) ? (currentKioskMode == lang['take_away'][language]) ? item.is_take_out : (currentKioskMode == lang['dine_in'][language] ? item.is_dine_in : true) : true)"
            @click="getCategories(item)"
            :style="
              item.Id == selectedMenuCategory.Id
                ? makeStyles(btnMainBackground,hasKiosk && mainButtonRadius )
                : makeStyles(btnSecondBackground,hasKiosk && secondButtonRadius)
            "
          >
            <div
              v-if="hasKiosk||item.parentCategoryId == 0"
              class="md:flex md:justify-between w-full">
              <div
                v-if="item.picture_url && menu.layout != 'frydate'"
                :class="[
                  'hidden ml-8 h-14 w-24 rounded-lg overflow-hidden md:flex items-center',
                ]"
                :style="
                  item.Id == selectedMenuCategory.Id ? btnMainText : btnSecondText
                "
              >
                <img
                  :src="item.picture_url"
                  alt
                  class="rounded-lg h-full object-cover"
                />
              </div>
              <div class="flex w-full justify-end flex-col text-center"
              :style="makeStyles(hasKiosk&&titleFont,hasKiosk&&titleTextTransform)"
              >
                <slot name="content" v-bind:data="item">
                  <div class="flex-1 flex items-center">
                    <div
                      :class="[
                        'text-sm font-semibold px-6 md:pr-0',
                        menu.layout == 'frydate' ? hasKiosk ? 'text-3xl uppercase' : 'text-xl uppercase' : '',
                        item.Id == selectedMenuCategory.Id
                          ? /*theme.body.selectedTextColor*/ 'text-white'
                          : /*theme.body.textColor,*/ 'text-primary-400 md:text-product-gray md:font-bold',
                      ]"
                      v-trans:name="item"
                      :style="makeStyles(
                        item.Id == selectedMenuCategory.Id
                          ? btnMainText
                          : btnSecondText,
                          hasKiosk && titleFont,
                            hasKiosk&&titleTextTransform
                            )"
                    ></div>
                  </div>
                </slot>
              </div>
              <div 
                v-if="!hasKiosk"
                class="hidden md:flex self-center">
                <div
                  class="bg-primary-100 rounded-full w-6 h-6 ml-4 mr-4 flex justify-center"
                  :style="additionAddBackground"
                >
                  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 320 512">
                    <path
                      d="M242.6 280.3l-103.9 82.2c-5 4-13.1 4-18.2 0l-12.1-9.6c-5-4-5-10.4 0-14.3l82.4-65.5-82.4-65.5c-5-4-5-10.4 0-14.3l12.1-9.6c5-4 13.1-4 18.2 0l103.9 82.2c5 4 5 10.4 0 14.4z"
                      :fill="buttonImgColors"
                    />
                  </svg>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div 
      v-if="isSearchEnable != 'false'"
      class="flex items-center md:hidden">
      <button @click="openSearchBar()">
      <svg class="inline mx-2" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="square" stroke-linejoin="arcs"><circle cx="11" cy="11" r="8"></circle><line x1="21" y1="21" x2="16.65" y2="16.65"></line></svg>
      </button>
      </div>
    </div>
    <div v-else>
      <div
        class="flex max-w-4/5 overflow-x-scroll md:overflow-y-scroll md:rounded-lg md:items-center md:justify-center md:bg-primary-50 rounded-xxl md:w-full w-full"
        :style="makeStyles(secondButtonRadius , btnSecondBackground)"
      >
       <div
          :class="[
            'relative flex md:flex-col md:h-auto h-12 self-center w-full justify-between',
          ]"
          :style="makeStyles(secondButtonRadius , btnSecondBackground)"
        >
        <input 
        :placeholder="lang['search'][language]"
        v-model="searchInputData"
        class="pl-3 w-full"
        :style="makeStyles(secondButtonRadius , btnSecondBackground)"/>
        <div class="flex items-center md:hidden">
        <button @click="closeSearchBar()">
        <svg class="mx-2" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="square" stroke-linejoin="arcs"><line x1="18" y1="6" x2="6" y2="18"></line><line x1="6" y1="6" x2="18" y2="18"></line></svg>
        </button>
        </div>
        </div>
      </div>
    </div>
    <div
      class="flex justify-center mb-2 mt-2"
      v-if="
        menu['temp_disabled_msg' + '_' + language] && !menu.is_ordering_enabled
      "
    >
      <p
        class="bg-red-600 text-white py-1 px-2 rounded-xl whitespace-normal text-center"
      >
        {{ menu["temp_disabled_msg" + "_" + language] }}
      </p>
    </div>
    <div>
      <div v-if="selectedMenuCategory.isVisible == true">
        <p
          v-if="
            selectedMenuCategory.ordering_start_time != '00:00:00' &&
            selectedMenuCategory.ordering_end_time != '00:00:00' &&
            !selectedMenuCategory.is_ordering_disabled
          "
          class="text-xs text-center mt-3 text-gray-700"
        >
          {{ selectedMenuCategory["name" + "_" + language] }}
          {{ lang["available_betweens"][language] }}
          <br>
          {{
            selectedMenuCategory.ordering_start_time
              ? selectedMenuCategory.ordering_start_time.slice(0, -3)
              : ""
          }}
          {{ lang["and_keyword"][language] }}
          {{
            selectedMenuCategory.ordering_end_time
              ? selectedMenuCategory.ordering_end_time.slice(0, -3)
              : ""
          }}
        </p>
      </div>
    </div>
  </div>
  <div v-if="!isMobileDevice"
  class=" w-11/12 w-full flex flex-col justify-center left-0 right-0"
  :style="
        hasKiosk &&
        menu.kiosk_checkout_height &&
        `margin-top:calc(${menu.kiosk_checkout_height}/2)`
      "
  >
    <vue-touch-keyboard
      v-if="visible"
      :cancel="hide"
      :accept="accept"
      :input="input"
      :options="{
        useKbEvents: false,
        preventClickEvent: false,
      }"
      :layout="layout"
    />
    </div>
  </div>
</template>
<script>
import { mapGetters } from "vuex";
import lang from "../lang";
import { layouts } from "../utils/vendors/touch-keyboard.vue";
// import IconHome from "../components/icons/iconHome.vue";
// import IconTruck from "../components/icons/iconTruck.vue";
export default {
  data() {
    return {
      data: {
        type: Array,
        required: false,
      },
      link: {
        type: String,
        required: false,
      },
      lang: lang,
      currentItem: {},
      itemBeingAdded: "",
      currentOption: "",
      position: { scrollTop: 0, scrollLeft: 0 },
      scrollPosition: false,
      searchBarActive: false,
      visible: false,
      input: undefined,
    };
  },
  components: {
    // IconHome, IconTruck
  },
  computed: {
    isListDisplayed: {
      get() {
        return this.$store.getters["isListDisplayed"];
      },
      set(value) {
        this.$store.commit("updateIsListDisplayed", value);
      },
    },
    searchInputData: {
      get() {
        return this.$store.getters["searchItemInput"];
      },
      set(value) {
        this.$store.commit("updateSearchItemInput",value)
      }
    },
    ...mapGetters([
      "infiniteScroll",
      "isMobileDevice",
      "language",
      "categoryId",
      "menuItems",
      "loadingItems",
      "currency",
      "theme",
      "selectedMenuCategory",
      "menuCategories",
      "hasKiosk",
      "menuHash",
      "currentKioskMode",
      "menu",
      "landingsPageDelivery",
      "isSearchKiosk"
    ]),
    ...mapGetters("Cart", ["cartItems"]),
    ...mapGetters("Theme", [
      "isSearchEnable",
      "mainButtonRadius",
      "btnMainBackground",
      "btnMainText",
      "titleFont",
      "titleTextTransform",
      "btnSecondBackground",
      "secondButtonRadius",
      "btnSecondText",
      "btnThirdBackground",
      "buttonImgColors",
      "additionAddBackground",
      "kioskKeyboardBackgroundColor",
      "kioskKeyboardKeyBackgroundColor",
      "kioskKeyboardKeyTextColor",
      "kioskKeyboardTextColor",
      "kioskKeyboardKeysRadius",
      "kioskSearchBorderColor",
      "kioskSearchTextColor",
      "kioskSearchIconColor",
    ]),
  },
  methods: {
    onScroll: function(e, position) {
      this.position = position;
      if (this.position.scrollLeft > 0) {
        this.scrollPosition = true;
      }

      if (this.position.scrollLeft < 1) {
        this.scrollPosition = false;
      }
    },

    /**
     * @params null
     * @returns null
     * scroll to make selected category into view
     */
    scrollSelectedCategoryIntoView() {
      this.$nextTick(() => {
        if(this.$refs?.menuCategoryId?.[0]&&this.$refs?.scrollbar){
          let activeBoundedClientRec=this.$refs.menuCategoryId[0].getBoundingClientRect();
          let scrollbarBoundedClientRec=this.$refs.scrollbar.getBoundingClientRect();
          if(activeBoundedClientRec.x<0){
            this.$refs.scrollbar.scroll(this.$refs.scrollbar.scrollLeft-this.$refs.scrollbar.offsetLeft+activeBoundedClientRec.x,0);
          }else if(activeBoundedClientRec.right>scrollbarBoundedClientRec.width){
              this.$refs.scrollbar.scroll(this.$refs.scrollbar.scrollLeft+activeBoundedClientRec.right-scrollbarBoundedClientRec.width,0)
          }
        }
      });
    },
    handleSearchKiosk() {
      if (this.hasKiosk) {
        this.$store.commit("updateIsSearchKiosk",true)        
      }
    },
    handleSearchCloseButton() {
      this.$store.commit("updateSearchItemInput","")
      if(this.isSearchKiosk) {
        this.$store.commit("updateIsSearchKiosk",false)    
        this.hide();
      }
    },
    show(e) {
      if (this.hasKiosk) {
        this.input = e.target;
        this.layout = layouts[`kiosk_${e.target.dataset.layout}`] || layouts.kiosk;
        
        if (!this.visible) this.visible = true;
      }
    },
    accept() {
      this.$modal.show('cart-items');
      if (this.cartItems.length > 0) {
        this.handleSearchCloseButton();
        this.hide();
        this.$store.dispatch("UPDATE_CART_PROCESS")
      }
    },
    hide() {
      this.visible = false;
    },
    openSearchBar() {
      this.searchBarActive = !this.searchBarActive
    },
    closeSearchBar() {
      this.searchBarActive = !this.searchBarActive;
      this.$store.commit("updateSearchItemInput","")
    },
    // get the categories and the subcategories (if there are any)
    getCategories(item) {
      this.$store.commit("updateSearchItemInput", "")
      this.$store.commit("updateIsSearchKiosk",false)
      if (item.Id == this.selectedMenuCategory) {
        return;
      }
      this.$store.commit("updateSelectedMenuCategory", item);
      this.$store.commit("updateCategoryId", item.Id);
      this.$store.commit("updateIsSubSubCategory", false);
      if (item.hasSubCategories) {
        this.$store.commit("updateSubCategoryId", item.Id);
        this.$store.dispatch("GET_MENU_SUB_CATEGORIES");
        this.$store.commit("updateMenuCategoriesCategories", item);

        this.$router
          .push("/" + this.$route.params.menuHash + "/category/" + item.Id)
          .catch(() => {});
      } else {
        if(this.infiniteScroll){
          this.$emit('category-changed',item.Id)
        }else{
          this.$store.dispatch("GET_CATEGORY");
          this.scrollSelectedCategoryIntoView();
        }
        this.$router
          .push("/" + this.$route.params.menuHash + "/sub/category/" + item.Id)
          .catch(() => {});
      }
    },
    getSubItems(menuItemId) {
      this.$router
        .push(
          "/" +
            this.$route.params.menuHash +
            "/category/" +
            this.$route.params.categoryId +
            "/menuItemId/" +
            menuItemId
        )
        .catch(() => {});
    },
  },
  mounted() {
    /** Check and update if url has sub category in parameter */
    if (this.$route.params.subCategoryId) {
      this.$store.commit(
        "updateSubCategoryId",
        this.$route.params.subCategoryId
      );
    }

    // checks if the localstorage language matches the restaurant, if not use the standard menu language
    this.$store.commit("updateCategoryId", this.$route.params.categoryId);
    if (
      localStorage.getItem("language") == this.menu.language ||
      (localStorage.getItem("language") == "nl" && this.menu.hasNL) ||
      (localStorage.getItem("language") == "fr" && this.menu.hasFR) ||
      (localStorage.getItem("language") == "de" && this.menu.hasDE) ||
      (localStorage.getItem("language") == "en" && this.menu.hasEN)
    ) {
      this.$store.commit("changeLanguage", localStorage.getItem("language"));
    }
    else {
      this.$store.commit("changeLanguage", this.menu.language);
    }

if(this.hasKiosk){
    /**
     * Scroll the horizontal selected item to center when menu is selected.
     */
    if (this.selectedMenuCategory && this.$route.name === "Category") {
      setTimeout(() => {
        this.$refs.menuCategoryId?.[0].scrollIntoViewIfNeeded({
          behavior: "smooth",
          inline: "center",
        });
      }, 2000);

      setTimeout(() => {
        this.$refs.menuCategoryId?.[0].scrollIntoViewIfNeeded({
          behavior: "smooth",
          inline: "center",
        });
      }, 500);
    }
    }
    this.scrollSelectedCategoryIntoView()
  },
  created() {
    this.currentOption = localStorage.getItem("currentOption");
  },
  updated() {
        /** It will focus the search field in kiosk mode if the page has just one input field so keyboard will come up */
    if(this.isSearchKiosk) {
    document.querySelector('.searchInput').focus()
    }
    let test = document.querySelectorAll(
      "body .vue-touch-keyboard .keyboard .control"
    );
    let keys = document.querySelectorAll(
      "body .vue-touch-keyboard .keyboard .key"
    );
    let enterKey = document.querySelectorAll(
      "body .vue-touch-keyboard .keyboard .accept"
    );
    for (let i = 0; i < enterKey.length; i++) {
      enterKey[i].style.backgroundImage = "url(data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiB2aWV3Qm94PSIwIDAgMjQgMjQiIGZpbGw9Im5vbmUiIHN0cm9rZT0iI2ZmZmZmZiIgc3Ryb2tlLXdpZHRoPSI0IiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS1saW5lam9pbj0icm91bmQiPjxwYXRoIGQ9Ik05IDE4bDYtNi02LTYiLz48L3N2Zz4=)"
    }

    for (let i = 0; i < keys.length; i++) {
      if (keys[i].textContent == "7") {
        keys[i].removeAttribute("style")
      }
      keys[i].style.borderRadius = this.kioskKeyboardKeysRadius;
      keys[i].style.backgroundColor = this.kioskKeyboardKeyBackgroundColor;
      keys[i].style.color = this.kioskKeyboardKeyTextColor;
    }
    for (let i = 0; i < test.length; i++) {
      test[i].style.backgroundColor = this.kioskKeyboardBackgroundColor;
      test[i].style.color = this.kioskKeyboardTextColor;
      test[i].style.borderColor = this.kioskKeyboardBackgroundColor;
    }
    
  }
};
</script>

<style scoped>
.whitespace {
  white-space: nowrap;
  padding-left: 20px;
  padding-right: 20px;
}

.arrowPosition {
  position: absolute;
  top: 0px;
  left: 15px;
  background: #e3e8fe;
  border-top-left-radius: 30px;
  border-bottom-left-radius: 30px;
  padding: 12px;
}

/* .shadowFade {
  box-shadow: 0px 0 white, 0px 0 white, 0 7px 5px -2px rgb(255, 255, 255);
  position: relative;
  z-index: 20;
} */
</style>
